import {
    Container as BaseContainer,
    styled,
    Switch,
} from "@material-ui/core";
import FullPageCircularProgress from "components/full-page-circular-progress";
import SectionGrid from "components/section-grid";
import { brand } from "../../theme";

export const Container = BaseContainer;

export const CircularProgress = FullPageCircularProgress;

export const AllowEditField = styled(
  ({ onChange, value, ...p }) => (
    <div {...p}>
      <div className="info">
        <div className="title">Allow Editing</div>
        <div className="subtitle">
          {value ? "Tap a round to edit your pick" : "Enable to change your picks"}
        </div>
      </div>
      <Switch
        color="primary"
        onChange={onChange}
        checked={Boolean(value)}
        inputProps={{ "aria-label": "Allow Editing" }}
      />
    </div>
  )
)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(2),
  padding: theme.spacing(1.5, 2),
  background: brand.white,
  borderBottom: `1px solid ${brand.sep}`,

  "& .info": {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    minWidth: 0,
  },
  "& .title": {
    fontWeight: 700,
    fontSize: 15,
    color: brand.text,
  },
  "& .subtitle": {
    fontSize: 12,
    color: brand.textSec,
  },
}));

export const Section = styled(SectionGrid)(({ theme }) => ({
  marginTop: 0,
  marginBottom: theme.spacing(8),

  "& .MuiList-root": {
    background: brand.white,
    padding: 0,
    borderBottom: `1px solid ${brand.sep}`,
  },
}));
